import React, {memo, useState} from 'react';
import './index.scss';
import {Container} from "../../components/Container";

export const EnergyScreen = memo(function EnergyScreen() {
    const [iframeUrl, setIframeUrl] = useState('http://127.0.0.1:8080/');
    return (
        <Container>
            <div className="page-wrapper">
                <div className="iframe-parent">
                    <iframe src={iframeUrl}/>
                </div>
            </div>
        </Container>
    );
});
